import Link from "next/link";
import authService from "@/service/authService";

/* eslint-disable react/prop-types */
function TopNavbar({ image, name }) {
    return (
        <nav className="sticky top-0 rounded-none bg-purple-100 shadow-sm z-[999]">
            <div className="flex items-center px-3 py-2 md:py-3 justify-between max-w-screen-2xl mx-auto">
                <Link href={'/'} className="flex items-center gap-2 md:gap-3">
                    <div className="flex justify-center">
                        <img 
                            className="w-8 h-8 md:w-10 md:h-10 object-contain" 
                            src={image} 
                            alt="App Logo" 
                        />
                    </div>
                    <h1 className="text-center bg-white text-black text-sm md:text-base lg:text-xl font-medium app-font px-2 py-1 md:px-3 md:py-2 rounded whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[160px] sm:max-w-xs">
                        {name} Dashboard
                    </h1>
                </Link>
            </div>
        </nav>
    )
}

export default TopNavbar;